export default "__VITE_ASSET__Dxc4WSZx__"